import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { SigninUser } from 'src/app/shared/model/SiginUser';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DashboardService } from 'src/app/shared/services/dashboard.service';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit {
  @ViewChild('navbar') navbarElement: ElementRef;
  user;
  userId;
  showMenu = false;
  isPasswordVisible = false;
  originalSigninUser: SigninUser = {
    email: '',
    password: ''
  };
  data: SigninUser = { ...this.originalSigninUser };
  
  constructor(
    private router: Router,
    public authService: AuthService,
    public dashboardService: DashboardService
  ) { 
    this.userId = localStorage.getItem('useremail');
        console.log(this.userId)
    
        if(this.userId) this.dashboardService.getUser(this.userId).pipe(take(1))
        .subscribe(user => this.user = user)
  }

  ngOnInit(): void {
  }
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    const navbar = document.querySelector('.navbar-custom');
    if (window.scrollY > 50) {
      navbar?.classList.add('scrolled');
    } else {
      navbar?.classList.remove('scrolled');
    }
  }
  toggleMenu(): void {
    this.showMenu = !this.showMenu;
    console.log('Menu toggled. showMenu is now:', this.showMenu);
  }
  closeMenu(): void {
    this.showMenu = false;
    console.log('Menu closed. showMenu is now:', this.showMenu);
  }
  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  get isDashboardRoute(): boolean {
    return this.router.url.startsWith('/dashboard');
  }
  get displayName(): string {
    const currentDisplayName = this.authService.userData?.displayName;
    if (currentDisplayName) {
      return currentDisplayName;
    }
    const rawUser = localStorage.getItem('user');
    if (!rawUser || rawUser === 'null') {
      return 'User';
    }
    try {
      const user = JSON.parse(rawUser);
      return user?.displayName || 'User';
    } catch {
      return 'User';
    }
  }
  async login(form: NgForm) {
    await this.authService.SignIn(this.data.email, this.data.password)
      .then(() => window.location.reload());
    form.reset();
    this.data = { ...this.originalSigninUser };
  }
}

